<script lang="ts">
export default {
    name: 'CommandsListButtons',
    components: {},
    props: {
        item: { type: Object, required: true },
        translationName: { type: String, required: true },
    },
    emits: ['viewRoute', 'updateRoute', 'deleteItem', 'createRoute'],
    data() {
        return {
        }
    },
    computed: {
    },
    methods: {
    },
}
</script>

<template>
    <v-btn
        v-if="item && $permissionCheck(`majic_command_show`) && !item.meta.editable && !item.meta.renewable"
        variant="text" prepend-icon="mdi-eye" size="small" density="compact"
        color="primary"
        @click="$emit('viewRoute', item)"
    >
        Voir
    </v-btn>

    <v-btn
        v-if="item && $permissionCheck(`majic_command_update`) && item.meta.editable"
        variant="text" prepend-icon="mdi-pencil" size="small" density="compact"
        color="primary"
        @click="$emit('updateRoute', item)"
    >
        Modifier
    </v-btn>

    <v-btn
        v-if="item && $permissionCheck(`majic_command_store`) && item.meta.renewable"
        variant="text" prepend-icon="mdi-refresh" size="small" density="compact"
        color="primary"
        @click="$emit('createRoute', item)"
    >
        Renouveler
    </v-btn>

    <ListDeleteConfirmation
        v-if="item && $permissionCheck(`majic_command_destroy`) && item.meta.deletable"
        :item="item"
        :translation-name
        button="<v-btn variant='text' prepend-icon='mdi-delete' size='small' density='compact' color='primary'>Supprimer</v-btn>"
        @delete-data="$emit('deleteItem')"
    />
</template>
